/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_S2_Li3Inputs */

const en_guide_what_is_json_s2_li3 = /** @type {(inputs: Guide_What_Is_Json_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Boolean</strong>: Logical values: <code>true</code> or <code>false</code>`)
};

const ko_guide_what_is_json_s2_li3 = /** @type {(inputs: Guide_What_Is_Json_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Boolean</strong>: 논리 값: <code>true</code> 또는 <code>false</code>`)
};

const ja_guide_what_is_json_s2_li3 = /** @type {(inputs: Guide_What_Is_Json_S2_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>ブーリアン</strong>: 論理値：<code>true</code>または<code>false</code>`)
};

/**
* | output |
* | --- |
* | "<strong>Boolean</strong>: Logical values: <code>true</code> or <code>false</code>" |
*
* @param {Guide_What_Is_Json_S2_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_s2_li3 = /** @type {((inputs?: Guide_What_Is_Json_S2_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_S2_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_s2_li3(inputs)
	if (locale === "ko") return ko_guide_what_is_json_s2_li3(inputs)
	return ja_guide_what_is_json_s2_li3(inputs)
});